(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9758],{

/***/ 84890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ ComponentErrorBoundary; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(95209);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(75815);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(18352);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(67573);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(90132);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(15375);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atomic/ComponentErrorBoundary/ComponentErrorBoundary.js











var ComponentErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ComponentErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ComponentErrorBoundary);
    function ComponentErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ComponentErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "reloadPage", function() {
            window.location.reload();
        });
        _this.state = {
            error: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(ComponentErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                var _this = this;
                esm_exports/* withScope */.$e(function(scope) {
                    scope.setExtras(errorInfo);
                    var errorState = esm_exports/* captureException */.Tb(error);
                    _this.setState({
                        error: errorState
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var error = this.state.error;
                if (error) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "alert alert-warning m-3 text-center",
                                role: "alert",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Oops! Something went wrong.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "Try reloading the page to correct this."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    onClick: function() {
                                        return _this.reloadPage();
                                    },
                                    label: "Reload Page",
                                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                                    size: system/* Size.Large */.$u.Large
                                })
                            })
                        ]
                    });
                }
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    error: true
                };
            }
        }
    ]);
    return ComponentErrorBoundary;
}(react.Component);


;// CONCATENATED MODULE: ./components/atomic/ComponentErrorBoundary/index.js



/***/ }),

/***/ 54131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* reexport */ Loader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/atomic/Loader/Loader.tsx



var Loader = function(param) {
    var _message = param.message, message = _message === void 0 ? "Loading..." : _message;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "loader--search",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/general/loading.gif"),
                alt: "loading",
                height: "75",
                width: "75",
                rel: "prefetch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-2",
                children: message
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/Loader/index.ts



/***/ }),

/***/ 19674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _pagination_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57807);
/* harmony import */ var _pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99280);








var Pagination = function(param) {
    var resultTotal = param.resultTotal, pageSize = param.pageSize, currentPage = param.currentPage, gotoPage = param.gotoPage;
    var getNumberOfPages = function(pageSize, resultTotal) {
        return Math.ceil(resultTotal / pageSize);
    };
    var isPreviousButtonDisabled = function(currentPage, totalPages) {
        return currentPage === 1 || totalPages === 0;
    };
    var isNextButtonDisabled = function(currentPage, totalPages) {
        return currentPage === totalPages || totalPages === 1 || totalPages === 0;
    };
    var pageUrl = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().asPath.split("?")[0];
    var totalPages = getNumberOfPages(pageSize, resultTotal);
    var isMobile = (0,react_responsive__WEBPACK_IMPORTED_MODULE_4__.useMediaQuery)({
        maxWidth: 991
    });
    var numberOfPagesDesktop = 5;
    var numberOfPagesMobile = 3;
    var maxPagesToDisplay = isMobile ? numberOfPagesMobile : numberOfPagesDesktop;
    var handleChange = function(page) {
        if (gotoPage) {
            gotoPage(page);
        }
    };
    var getPagesToDisplay = function(currentPage, totalPages) {
        var pages = [];
        var numberOfPagesToDisplay = maxPagesToDisplay > totalPages ? totalPages : maxPagesToDisplay;
        if (currentPage === 1 || currentPage === 2 || currentPage === 3) {
            // currentPage is at the minimum
            for(var i = 1; i <= numberOfPagesToDisplay; i++){
                pages.push(i);
            }
        } else if (currentPage + 2 < totalPages && currentPage - 2 > 1) {
            // currentPage is in the middle
            for(var i1 = currentPage - 2; i1 <= currentPage + 2; i1++){
                pages.push(i1);
            }
        } else if (currentPage === totalPages || currentPage === totalPages - 1 || currentPage === totalPages - 2) {
            // currentPage is up at the maximum
            for(var i2 = totalPages - numberOfPagesToDisplay === 0 ? 1 : totalPages - numberOfPagesToDisplay; i2 <= totalPages; i2++){
                pages.push(i2);
            }
        }
        return pages;
    };
    var pages = getPagesToDisplay(currentPage, totalPages).map(function(pageId) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(pageId === currentPage ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "".concat(pageUrl, "?page=").concat(pageId),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                    onClick: function() {
                        return handleChange(pageId);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "sr-only",
                            children: "Page "
                        }),
                        pageId
                    ]
                })
            })
        }, pageId);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
        "aria-label": "Page navigation",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pagination),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isPreviousButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=1"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(1);
                            },
                            "aria-label": "First",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevrons-left.svg"),
                                    alt: "",
                                    height: "16",
                                    width: "16"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isPreviousButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=").concat(currentPage - 1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(currentPage - 1);
                            },
                            "aria-label": "Previous",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevron-left.svg"),
                                    alt: "chevron left icon",
                                    height: "16",
                                    width: "16"
                                })
                            })
                        })
                    })
                }),
                pages,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isNextButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=").concat(currentPage + 1),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(currentPage + 1);
                            },
                            "aria-label": "Next",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevron-right.svg"),
                                    alt: "chevron right icon",
                                    height: "16",
                                    width: "16"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "".concat((_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-item"]), " ").concat(isNextButtonDisabled(currentPage, totalPages) ? (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default().disabled) : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                        href: "".concat(pageUrl, "?page=").concat(totalPages),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["page-link"]),
                            onClick: function() {
                                return handleChange(totalPages);
                            },
                            "aria-label": "Last",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                src: "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.imageHost.assets */ ._G.imageHost.assets, "/icons/library/chevrons-right.svg"),
                                alt: "",
                                height: "16",
                                width: "16"
                            })
                        })
                    })
                })
            ]
        })
    });
};
Pagination.propTypes = {
    resultTotal: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    pageSize: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    currentPage: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    gotoPage: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func.isRequired)
};


/***/ }),

/***/ 15527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* reexport */ SupportTab; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/atomic/SupportTab/SupportTab.tsx



var FeedbackModal = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(9575), __webpack_require__.e(7624)]).then(__webpack_require__.bind(__webpack_require__, 77624));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77624)
            ];
        }
    },
    ssr: false
});
var SupportTab = function() {
    var onClickButton = function() {
        esm/* default.show */.ZP.show(FeedbackModal, {
            isAdvertisingModal: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        onClick: onClickButton,
        className: "support-tab",
        type: "button",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "Feedback"
        })
    });
};

;// CONCATENATED MODULE: ./components/atomic/SupportTab/index.ts



/***/ }),

/***/ 24313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ TextSearch; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./components/search/inputs/TextSearch/text-search.module.scss
var text_search_module = __webpack_require__(58802);
var text_search_module_default = /*#__PURE__*/__webpack_require__.n(text_search_module);
;// CONCATENATED MODULE: ./lib/hooks/useDebounce.ts

function useDebounce(value, delay) {
    var ref = (0,react.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}

// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var search = __webpack_require__(29109);
// EXTERNAL MODULE: ./store/selectors/search.js
var selectors_search = __webpack_require__(29906);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/search/inputs/TextSearch/TextSearch.tsx










var Icon = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(6244)]).then(__webpack_require__.bind(__webpack_require__, 56244));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56244)
            ];
        }
    },
    ssr: false
});
var SEARCH_TEXT_WRITE_DELAY = 800;
var TextSearch = function(param) {
    var _visibleFilters = param.visibleFilters, visibleFilters = _visibleFilters === void 0 ? [] : _visibleFilters, _isVans = param.isVans, isVans = _isVans === void 0 ? false : _isVans, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? true : _isMobile;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storedTextSearch = (0,es/* useSelector */.v9)(selectors_search/* selectSearchTerm */.$p);
    var ref = (0,react.useState)(storedTextSearch), localSearchTerm = ref[0], setLocalSearchTerm = ref[1];
    var ref1 = (0,react.useState)(true), isInitialLoad = ref1[0], setIsInitialLoad = ref1[1];
    var debouncedSearchTerm = useDebounce(localSearchTerm, SEARCH_TEXT_WRITE_DELAY);
    (0,react.useEffect)(function() {
        if (!isInitialLoad) {
            dispatch((0,search/* storeSearchParameters */.rq)({
                filter: "searchTerm",
                value: debouncedSearchTerm,
                visibleFilters: visibleFilters
            }));
        }
        if (debouncedSearchTerm !== "") {
            setIsInitialLoad(false);
        }
    }, [
        dispatch,
        debouncedSearchTerm,
        isInitialLoad
    ]);
    (0,react.useEffect)(function() {
        setLocalSearchTerm(storedTextSearch);
    }, [
        storedTextSearch
    ]);
    var onKeyboardEnter = function(event) {
        if (event.code === "Enter") {
            event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat((text_search_module_default()).label, " sr-only"),
                children: "Search"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (text_search_module_default()).input,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (text_search_module_default()).icon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            size: system/* Size.Medium */.$u.Medium,
                            name: "Search"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        className: "".concat((text_search_module_default())["search--input"]).concat(!(0,utilities_system/* isProd */.BB)() ? " search__search-input" : ""),
                        onChange: function(e) {
                            return setLocalSearchTerm(e.target.value);
                        },
                        placeholder: isMobile ? "Search" : isVans ? "eg. Renault, transit or crew van" : "eg. Audi, 3 series or hatchback",
                        type: "search",
                        value: localSearchTerm,
                        "aria-label": isMobile ? "Search" : isVans ? "eg. Renault, transit or crew van" : "eg. Audi, 3 series or hatchback",
                        maxLength: 50,
                        onKeyDown: onKeyboardEnter
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/search/inputs/TextSearch/index.ts



/***/ }),

/***/ 30522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SaveTrigger; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25362);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14416);
/* harmony import */ var _components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96732);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99280);
/* harmony import */ var _lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13732);
/* harmony import */ var _store_actions_event__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61748);
/* harmony import */ var _store_selectors_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15433);
/* harmony import */ var _types_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16693);
/* harmony import */ var _lib_utilities_system__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(70591);











var SaveModal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4464), __webpack_require__.e(6533)]).then(__webpack_require__.bind(__webpack_require__, 50119));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50119)
            ];
        }
    },
    ssr: false
});
var AuthenticationModal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5808), __webpack_require__.e(9161), __webpack_require__.e(8246), __webpack_require__.e(9203)]).then(__webpack_require__.bind(__webpack_require__, 93418));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93418)
            ];
        }
    },
    ssr: false
});
var SaveTrigger = function(param) {
    var hierarchy = param.hierarchy;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var isAuthenticated = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(_store_selectors_user__WEBPACK_IMPORTED_MODULE_7__/* .selectIsAuthenticated */ .vN);
    var openSaveSearchModal = function() {
        if (isAuthenticated) {
            _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].show */ .ZP.show(SaveModal);
        } else {
            _ebay_nice_modal_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].show */ .ZP.show(AuthenticationModal, {
                initialStatus: _lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .STATUS_LOGIN */ .NN
            });
            (0,_lib_utilities_vehicle__WEBPACK_IMPORTED_MODULE_6__/* .addToDataLayer */ .Bk)({
                event: "search-filter",
                "filter-event": "login-modal"
            });
            dispatch((0,_store_actions_event__WEBPACK_IMPORTED_MODULE_10__/* .postAnalyticsEvent */ .gR)({
                event: _lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .constants.eventTypes.saveSearch */ ._G.eventTypes.saveSearch,
                payload: {
                    authenticated: true
                }
            }));
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_styleguide_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
        size: _types_system__WEBPACK_IMPORTED_MODULE_8__/* .Size.Medium */ .$u.Medium,
        hierarchy: hierarchy,
        icon: "Heart",
        onClick: openSaveSearchModal,
        label: "Save search",
        className: !(0,_lib_utilities_system__WEBPACK_IMPORTED_MODULE_9__/* .isProd */ .BB)() ? "search__save-search-button" : ""
    });
};


/***/ }),

/***/ 28496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ InformationBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/styleguide/InformationBanner/information-banner.module.scss
var information_banner_module = __webpack_require__(62312);
var information_banner_module_default = /*#__PURE__*/__webpack_require__.n(information_banner_module);
;// CONCATENATED MODULE: ./components/styleguide/InformationBanner/InformationBanner.tsx


var InformationBanner = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (information_banner_module_default()).container,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/styleguide/InformationBanner/index.ts



/***/ }),

/***/ 27838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ LocoScore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/loco-score.module.scss
var loco_score_module = __webpack_require__(53644);
var loco_score_module_default = /*#__PURE__*/__webpack_require__.n(loco_score_module);
;// CONCATENATED MODULE: ./components/styleguide/LocoScore/LocoScore.tsx



var LocoScore = function(param) {
    var rating = param.rating, _className = param.className, className = _className === void 0 ? "" : _className, _iconOnly = param.iconOnly, iconOnly = _iconOnly === void 0 ? false : _iconOnly, _isInline = param.isInline, isInline = _isInline === void 0 ? false : _isInline;
    var ref = (0,react.useState)("0, 100"), strokeDasharray = ref[0], setStrokeDasharray = ref[1];
    var ref1 = (0,react.useState)("#FFCC00"), colour = ref1[0], setColour = ref1[1];
    var ref2 = (0,react.useState)(0), currentRating = ref2[0], setCurrentRating = ref2[1];
    var PERFECT_SCORE = 73;
    (0,react.useEffect)(function() {
        // Setting up the dynamic keyframe end value when the component mounts or `rating` changes
        if (currentRating !== rating) {
            var animationCSS = "".concat(rating / 100 * PERFECT_SCORE, ", 100");
            var animation = setTimeout(function() {
                setStrokeDasharray(animationCSS);
                setColour(rating >= 80 ? "#FF2D55" : rating > 70 ? "#F15A24" : "#FFCC00");
                setCurrentRating(rating);
            }, 5);
            return function() {
                clearTimeout(animation);
            };
        }
    }, [
        currentRating,
        rating
    ]);
    var getDescriptionFromRating = function() {
        if (rating >= 90) {
            return "Amazing value";
        } else if (rating >= 80) {
            return "Great value";
        } else if (rating >= 70) {
            return "Fair value";
        } else {
            return "Low value";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((loco_score_module_default()).container, " ").concat(className),
        "data-is-inline": isInline,
        "data-icon-only": iconOnly,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    position: "relative",
                    display: "grid",
                    placeItems: "center",
                    height: 34,
                    width: 34
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        className: (loco_score_module_default()).ring,
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 4
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: colour,
                            style: {
                                strokeDasharray: strokeDasharray
                            },
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "34",
                        height: "30",
                        viewBox: "0 0 34 30",
                        fill: "none",
                        style: {
                            position: "absolute",
                            inset: 0,
                            zIndex: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M6.5 28C3.60451 25.1157 1.5 21.5 1.5 17C1.5 9 8.78728 1.5 17 1.5C25.2127 1.5 32.2701 8.94483 32.4028 17.3729C32.3374 21.3134 30.7773 24.992 27.5 28",
                            stroke: "#E5E5EA",
                            strokeLinecap: "round",
                            strokeWidth: "3"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (loco_score_module_default()).score,
                        style: {
                            color: colour
                        },
                        children: rating
                    }),
                    rating > 90 && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        width: "14",
                        height: "13",
                        viewBox: "0 0 14 13",
                        fill: "none",
                        className: (loco_score_module_default()).flame,
                        style: {
                            position: "absolute",
                            bottom: 0
                        },
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M5.19652 8.10588C5.53809 8.10588 5.86567 7.9702 6.10719 7.72867C6.34872 7.48715 6.4844 7.15957 6.4844 6.818C6.4844 6.1071 6.22683 5.7877 5.96925 5.27255C5.41701 4.16858 5.85386 3.18413 6.99955 2.18164C7.25713 3.46952 8.02986 4.70588 9.06016 5.53013C10.0905 6.35437 10.6056 7.33316 10.6056 8.36346C10.6056 8.83701 10.5123 9.30593 10.3311 9.74344C10.1499 10.1809 9.88428 10.5785 9.54942 10.9133C9.21457 11.2482 8.81704 11.5138 8.37953 11.695C7.94203 11.8762 7.47311 11.9695 6.99955 11.9695C6.526 11.9695 6.05708 11.8762 5.61957 11.695C5.18207 11.5138 4.78454 11.2482 4.44968 10.9133C4.11483 10.5785 3.84921 10.1809 3.66799 9.74344C3.48677 9.30593 3.39349 8.83701 3.39349 8.36346C3.39349 7.76949 3.61655 7.1817 3.90865 6.818C3.90865 7.15957 4.04433 7.48715 4.28586 7.72867C4.52738 7.9702 4.85496 8.10588 5.19652 8.10588Z",
                            fill: "#FF2D55"
                        })
                    })
                ]
            }),
            !iconOnly && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (loco_score_module_default()).text,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).title,
                        children: "LocoScore"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (loco_score_module_default()).description,
                        children: getDescriptionFromRating()
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/LocoScore/index.ts



/***/ }),

/***/ 52733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ VehicleImage; },
  "C": function() { return /* reexport */ VehicleImageWithGallery; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/vehicle-image.module.scss
var vehicle_image_module = __webpack_require__(80001);
var vehicle_image_module_default = /*#__PURE__*/__webpack_require__.n(vehicle_image_module);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImage.tsx




var VehicleImage = function(param) {
    var alt = param.alt, height = param.height, width = param.width, imagePath = param.imagePath, backupImagePath = param.backupImagePath, _priority = param.priority, priority = _priority === void 0 ? false : _priority, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "\n        ".concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && imagePath ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(!imagePath ? (vehicle_image_module_default())["padded-image"] : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: imagePath ? (0,vehicle/* getGalleryImage */.Dq)(imagePath) : (0,vehicle/* getVehicleHeroImage */.Nk)(backupImagePath),
            alt: alt,
            height: height,
            width: width,
            priority: priority,
            quality: quality,
            layout: layout,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            className: className,
            unoptimized: unoptimized
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/VehicleImageWithGallery.tsx








var VehicleImageWithGallery = function(param) {
    var alt = param.alt, height = param.height, width = param.width, images = param.images, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality, _layout = param.layout, layout = _layout === void 0 ? undefined : _layout, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? undefined : _placeholder, blurDataURL = param.blurDataURL, _className = param.className, className = _className === void 0 ? "" : _className, _unoptimized = param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _type = param.type, type = _type === void 0 ? "DEFAULT" : _type, _showDots = param.showDots, showDots = _showDots === void 0 ? true : _showDots, _alignDots = param.alignDots, alignDots = _alignDots === void 0 ? "center" : _alignDots, onChangeIndex = param.onChangeIndex;
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useRef)(null);
    var onChangeCurrentIndex = function(index) {
        if (onChangeIndex) {
            onChangeIndex(index);
        }
        setCurrentIndex(index);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (vehicle_image_module_default()).wrapper,
        "data-type": type,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: ref1,
                className: (vehicle_image_module_default()).carousel,
                onScroll: function(e) {
                    var target = e.target;
                    var calculation = Math.floor(target.scrollLeft / target.children[0].clientWidth);
                    onChangeCurrentIndex(calculation < 0 ? 0 : calculation);
                },
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                        triggerOnce: true,
                        duration: 1000,
                        className: (vehicle_image_module_default()).item,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-index": index,
                            className: "".concat((vehicle_image_module_default()).content, " ").concat(type !== "GALLERY" && type !== "BROWSE" && type !== "HOMEPAGE" && image.path ? (vehicle_image_module_default())["reverse-image"] : "", " ").concat(type === "SPEC" ? (vehicle_image_module_default())["spec-image"] : ""),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (0,vehicle/* getGalleryImage */.Dq)(image.path),
                                alt: alt,
                                height: height,
                                width: width,
                                quality: quality,
                                layout: layout,
                                placeholder: placeholder,
                                blurDataURL: blurDataURL,
                                className: className,
                                unoptimized: unoptimized
                            })
                        })
                    }, image.id);
                })
            }),
            showDots && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (vehicle_image_module_default()).dots,
                "data-alignment": alignDots,
                children: images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).map(function(image, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((vehicle_image_module_default()).dot).concat(currentIndex === index ? " " + (vehicle_image_module_default()).active : "").concat(Math.abs(currentIndex - index) > 2 ? Math.abs(currentIndex - index) >= 4 ? " " + (vehicle_image_module_default())["too-far"] : " " + (vehicle_image_module_default()).far : Math.abs(currentIndex - index) > 1 ? " " + (vehicle_image_module_default()).close : "")
                    }, image.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (vehicle_image_module_default()).arrows,
                "data-navigation-position": currentIndex === 0 ? "start" : currentIndex === images.filter(function(image) {
                    return image.angleType === "EXTERIOR";
                }).sort(function(a) {
                    return a.angle === "lowaggressive" ? -1 : 1;
                }).length - 1 ? "end" : "middle",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft - ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        icon: "ChevronLeft",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled,
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        onClick: function() {
                            var ref, ref2, ref3;
                            ref1 === null || ref1 === void 0 ? void 0 : (ref = ref1.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
                                left: ref1.current.scrollLeft + ((ref3 = ref1 === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.children[0]) === null || ref3 === void 0 ? void 0 : ref3.clientWidth),
                                behavior: "smooth"
                            });
                        },
                        theme: type === "SPEC" ? system/* Theme.light */.Q2.light : system/* Theme.dark */.Q2.dark,
                        icon: "ChevronRight",
                        size: system/* Size.ExtraSmall */.$u.ExtraSmall,
                        hierarchy: type === "SPEC" ? Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray : Button/* ButtonHierarchy.Filled */.B.Filled
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/VehicleImage/index.ts




/***/ }),

/***/ 80303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ SearchResultsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SearchResultsContainer = function(param) {
    var _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _hasNoResults = param.hasNoResults, hasNoResults = _hasNoResults === void 0 ? false : _hasNoResults, _layout = param.layout, layout = _layout === void 0 ? "grid" : _layout, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: isLoading ? "container--loading" : "container--search-results",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat(layout, " search__results ").concat(hasNoResults ? "search__results--no-results" : ""),
            children: children
        })
    });
};


/***/ }),

/***/ 2374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ SearchResultsAndFilters; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/react-spring-bottom-sheet/dist/index.es.js + 57 modules
var index_es = __webpack_require__(30535);
// EXTERNAL MODULE: ./components/atomic/SupportTab/index.ts + 1 modules
var SupportTab = __webpack_require__(15527);
// EXTERNAL MODULE: ./components/search/inputs/TextSearch/index.ts + 2 modules
var TextSearch = __webpack_require__(24313);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./components/atomic/ComponentErrorBoundary/index.js + 1 modules
var ComponentErrorBoundary = __webpack_require__(84890);
// EXTERNAL MODULE: ./components/atomic/Loader/index.ts + 1 modules
var Loader = __webpack_require__(54131);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/styleguide/SellYourVehicleBanner/sell-your-vehicle-banner.module.scss
var sell_your_vehicle_banner_module = __webpack_require__(17490);
var sell_your_vehicle_banner_module_default = /*#__PURE__*/__webpack_require__.n(sell_your_vehicle_banner_module);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
;// CONCATENATED MODULE: ./components/styleguide/SellYourVehicleBanner/SellYourVehicleBanner.tsx




var SellYourVehicleBanner = function(param) {
    var isVans = param.isVans, page = param.page, position = param.position;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (sell_your_vehicle_banner_module_default()).main,
        href: "".concat(constants/* constants.sellYourVehicleUrl.dealPage */._G.sellYourVehicleUrl.dealPage).concat(isVans ? "/sell-my-van?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=".concat(position, "-").concat(page) : "/partner/leaseloco?utm_source=leaseloco&utm_medium=affiliate&utm_campaign=".concat(position, "-").concat(page)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sell_your_vehicle_banner_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (sell_your_vehicle_banner_module_default()).title,
                        children: [
                            "The easy way to sell your ",
                            isVans ? "van" : "car"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (sell_your_vehicle_banner_module_default()).text,
                        children: "Get the best price from 7,500+ dealers"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (sell_your_vehicle_banner_module_default()).end,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/affiliate/logo/motorway.svg"),
                        width: 90,
                        height: 18,
                        alt: "Motorway logo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (sell_your_vehicle_banner_module_default()).button,
                        children: [
                            "Value your ",
                            isVans ? "van" : "car"
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/styleguide/SellYourVehicleBanner/index.ts


// EXTERNAL MODULE: ./components/views/SearchResults/views/NoResults/no-results.module.scss
var no_results_module = __webpack_require__(77513);
var no_results_module_default = /*#__PURE__*/__webpack_require__.n(no_results_module);
// EXTERNAL MODULE: ./components/styleguide/InformationBanner/index.ts + 1 modules
var InformationBanner = __webpack_require__(28496);
// EXTERNAL MODULE: ./store/selectors/search.js
var search = __webpack_require__(29906);
;// CONCATENATED MODULE: ./components/views/SearchResults/views/NoResults/NoResults.js









var AppliedFilters = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2717).then(__webpack_require__.bind(__webpack_require__, 72717));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72717)
            ];
        }
    },
    ssr: false
});
var NoResults = function(param) {
    var isVans = param.isVans;
    var hasSearchTerm = (0,es/* useSelector */.v9)(search/* selectSearchTerm */.$p);
    var searchRequest = (0,es/* useSelector */.v9)(search/* selectSearchParameters */.li);
    var ranges = (0,es/* useSelector */.v9)(search/* selectRangesForManufacturers */._f);
    var searchRequestCount = (0,es/* useSelector */.v9)(search/* selectCountOfSearchParameters */.F_);
    var vehicleTags = (0,es/* useSelector */.v9)(search/* selectAvailableVehicleTags */.cW);
    var vehiclePriceTags = (0,es/* useSelector */.v9)(search/* selectAvailableVehiclePriceTags */.Ge);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (no_results_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationBanner/* InformationBanner */.C, {
                children: hasSearchTerm ? constants/* constants.searchAlertMessages.withTextSearch */._G.searchAlertMessages.withTextSearch : isVans ? constants/* constants.searchAlertMessages.vanDefault */._G.searchAlertMessages.vanDefault : constants/* constants.searchAlertMessages.carDefault */._G.searchAlertMessages.carDefault
            }),
            searchRequestCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "search-results__applied-filters",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Search filters currently applied:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                            triggerOnce: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppliedFilters, {
                                filterLimit: 100,
                                search: {
                                    searchRequest: searchRequest
                                },
                                ranges: ranges,
                                vehicleTags: vehicleTags,
                                vehiclePriceTags: vehiclePriceTags,
                                hideDefaults: true
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/SearchResults/views/NoResults/index.js


// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/atomic/Pagination/Pagination.js
var Pagination = __webpack_require__(19674);
;// CONCATENATED MODULE: ./components/views/SearchResults/views/Pagination/Pagination.js







var SearchPagination = function() {
    var resultsTotal = (0,es/* useSelector */.v9)(search/* selectResultsTotal */.aS);
    var pagination = (0,es/* useSelector */.v9)(search/* selectPagination */.B$);
    var router = (0,next_router.useRouter)();
    var gotoPage = function(page) {
        var newQueryWithChangedPage = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
            page: page
        });
        router.push({
            pathname: router.pathname,
            query: newQueryWithChangedPage
        });
    };
    if (resultsTotal > 10) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "search-pagination",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                resultTotal: resultsTotal,
                pageSize: pagination.pageSize,
                currentPage: pagination.page,
                gotoPage: gotoPage
            })
        });
    }
    return null;
};

;// CONCATENATED MODULE: ./components/views/SearchResults/views/Pagination/index.js


// EXTERNAL MODULE: ./components/styleguide/Card/Vehicle/VehicleCard.tsx
var VehicleCard = __webpack_require__(63052);
;// CONCATENATED MODULE: ./components/views/SearchResults/views/SearchResultList.js


var SearchResultList = function(param) {
    var items = param.items, layoutType = param.layoutType;
    return items.map(function(item, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleCard/* VehicleCard */.U, {
            type: layoutType,
            deal: item,
            item: item,
            isPriority: index < 2
        }, item.vehiclePrice.id);
    });
};

// EXTERNAL MODULE: ./components/views/SearchResults/views/SearchResultsContainer.js
var SearchResultsContainer = __webpack_require__(80303);
// EXTERNAL MODULE: ./lib/errors.js + 3 modules
var errors = __webpack_require__(82628);
// EXTERNAL MODULE: ./store/selectors/error.js
var selectors_error = __webpack_require__(92311);
;// CONCATENATED MODULE: ./components/views/SearchResults/SearchResults.js
















var LocoSnaps = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7568), __webpack_require__.e(3133), __webpack_require__.e(6389)]).then(__webpack_require__.bind(__webpack_require__, 87255));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87255)
            ];
        }
    },
    ssr: false
});
var SearchResults = function(param) {
    var isVans = param.isVans, status = param.status, _layoutType = param.layoutType, layoutType = _layoutType === void 0 ? "grid" : _layoutType;
    var ref = (0,react.useState)(0), resultCount = ref[0], setResultCount = ref[1];
    var ref1 = (0,react.useState)(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING), componentStatus = ref1[0], setComponentStatus = ref1[1];
    var leaseType = (0,es/* useSelector */.v9)(search/* selectLeaseType */.Lz);
    var results = (0,es/* useSelector */.v9)(search/* selectSearchResultDeals */.yw);
    var error = (0,es/* useSelector */.v9)(function(state) {
        return (0,selectors_error/* selectErrorMessage */.JS)(state, errors/* ERRORS.fetchingSearchResults */.Sg.fetchingSearchResults);
    });
    (0,react.useEffect)(function() {
        setResultCount(results.length);
        if (results.length === 0) {
            setComponentStatus(constants/* constants.componentStatus.NOT_FOUND */._G.componentStatus.NOT_FOUND);
        }
    }, [
        results
    ]);
    (0,react.useEffect)(function() {
        if (status === constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING) {
            setComponentStatus(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING);
        } else {
            setComponentStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE);
        }
    }, [
        status
    ]);
    if (error) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultsContainer/* SearchResultsContainer */.q, {
            isLoading: componentStatus === constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING,
            hasNoResults: true,
            isVans: isVans,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 p-0 mt-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "alert alert-warning",
                            role: "alert",
                            children: error
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellYourVehicleBanner, {
                    position: "bottom",
                    page: "browse",
                    isVans: isVans
                })
            ]
        });
    }
    if (status !== constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE && componentStatus !== constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer/* SearchResultsContainer */.q, {
                    isVans: isVans,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container--search-loader",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                            triggerOnce: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "loader__wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                                    message: "Searching"
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellYourVehicleBanner, {
                    position: "bottom",
                    page: "browse",
                    isVans: isVans
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsContainer/* SearchResultsContainer */.q, {
            isVans: isVans,
            layout: layoutType,
            hasNoResults: resultCount === 0 && componentStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComponentErrorBoundary/* ComponentErrorBoundary */.O, {
                children: [
                    resultCount > 0 && componentStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultList, {
                        layoutType: layoutType,
                        items: isVans || leaseType === constants/* FILTER_LEASE_TYPES_BUSINESS */.kG ? results : results.slice(0, 6)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {
                        isVans: isVans
                    }),
                    !isVans && leaseType === constants/* FILTER_LEASE_TYPES_PERSONAL */.m_ && resultCount > 0 && componentStatus === constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocoSnaps, {
                                leaseType: leaseType
                            }),
                            resultCount > 6 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultList, {
                                items: results.slice(6)
                            })
                        ]
                    }),
                    resultCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPagination, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellYourVehicleBanner, {
                                position: "bottom",
                                page: "browse",
                                isVans: isVans
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/views/SearchResults/index.js


// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(17857);
// EXTERNAL MODULE: ./components/views/SearchResultsToolbar/search-results-toolbar.module.scss
var search_results_toolbar_module = __webpack_require__(89585);
var search_results_toolbar_module_default = /*#__PURE__*/__webpack_require__.n(search_results_toolbar_module);
// EXTERNAL MODULE: ./node_modules/react-detect-click-outside/dist/index.js
var react_detect_click_outside_dist = __webpack_require__(49689);
// EXTERNAL MODULE: ./components/atomic/SortByDropdown/sort-by-dropdown.module.scss
var sort_by_dropdown_module = __webpack_require__(61016);
var sort_by_dropdown_module_default = /*#__PURE__*/__webpack_require__.n(sort_by_dropdown_module);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./store/reducers/search.js + 1 modules
var reducers_search = __webpack_require__(29109);
// EXTERNAL MODULE: ./store/selectors/user.js
var user = __webpack_require__(15433);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/atomic/SortByDropdown/SortByDropdown.js












var SortByDropdown = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var sortBy = (0,es/* useSelector */.v9)(search/* selectSortBy */.C9);
    var experiment = (0,es/* useSelector */.v9)(user/* selectExperiment */.Oe);
    var ref = (0,react.useState)(false), isOptionsOpen = ref[0], setIsOptionsOpen = ref[1];
    var ref1 = (0,react.useState)(sortBy), selectedOption = ref1[0], setSelectedOption = ref1[1];
    var toggleOptions = function() {
        setIsOptionsOpen(function(isOptionsOpen) {
            return !isOptionsOpen;
        });
    };
    var closeOptions = function() {
        setIsOptionsOpen(false);
    };
    var onChange = function(sortId) {
        dispatch((0,reducers_search/* storeSearchParameters */.rq)({
            filter: "sortBy",
            value: Number(sortId)
        }));
    };
    var handleKeyDown = function(item) {
        return function(e) {
            switch(e.key){
                case " ":
                case "SpaceBar":
                case "Enter":
                    e.preventDefault();
                    setSelectedOption(item);
                    setIsOptionsOpen(false);
                    onChange(constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].value);
                    break;
                default:
                    break;
            }
        };
    };
    var ref2 = (0,react_detect_click_outside_dist/* useDetectClickOutside */.I)({
        onTriggered: closeOptions
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                size: system/* Size.Medium */.$u.Medium,
                label: "Sort by",
                hierarchy: Button/* ButtonHierarchy.Outline */.B.Outline,
                hasBackground: false,
                iconPosition: "right",
                icon: "ChevronDown",
                "aria-haspopup": "listbox",
                "aria-expanded": isOptionsOpen,
                id: "sort-by",
                onClick: toggleOptions
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "".concat((sort_by_dropdown_module_default()).options, " ").concat(isOptionsOpen ? (sort_by_dropdown_module_default()).show : ""),
                tabIndex: -1,
                role: "listbox",
                "aria-activedescendant": Object.keys(constants/* constants.searchSortingOptions */._G.searchSortingOptions)[0],
                children: Object.keys(constants/* constants.searchSortingOptions */._G.searchSortingOptions).map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        tabIndex: 0,
                        id: item,
                        role: "option",
                        "aria-selected": selectedOption === item,
                        onKeyDown: handleKeyDown(item),
                        onClick: function() {
                            if (selectedOption === constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].value) {
                                setIsOptionsOpen(false);
                                return;
                            }
                            setSelectedOption(constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].value);
                            setIsOptionsOpen(false);
                            (0,vehicle/* addToDataLayer */.Bk)({
                                event: "search-filter",
                                "filter-event": "sort-by",
                                "filter-label": constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].label,
                                experimentGroup: experiment.group
                            });
                            onChange(constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].value);
                        },
                        children: constants/* constants.searchSortingOptions */._G.searchSortingOptions[item].label
                    }, item);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/SortByDropdown/index.js


// EXTERNAL MODULE: ./components/search/saved-search/SaveTrigger.tsx
var SaveTrigger = __webpack_require__(30522);
// EXTERNAL MODULE: ./lib/utilities/system.js + 1 modules
var utilities_system = __webpack_require__(70591);
;// CONCATENATED MODULE: ./components/views/SearchResultsToolbar/SearchResultsToolbar.js














var SearchResultsToolbar = function(param) {
    var layoutType = param.layoutType, setLayoutType = param.setLayoutType, _isVans = param.isVans, isVans = _isVans === void 0 ? false : _isVans;
    var pricesTotal = (0,es/* useSelector */.v9)(search/* selectPricesTotal */.ME);
    (0,react.useEffect)(function() {
        // adds default layoutType to DL
        (0,vehicle/* addToDataLayer */.Bk)({
            browseLayout: layoutType
        });
    }, [
        layoutType
    ]);
    var handleLayoutChange = function(newLayoutType) {
        setLayoutType(newLayoutType);
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var twoWeeks = 1209600000;
            (0,utilities_system/* setWithExpiry */.w4)(constants/* constants.localStorageKey.browseLayoutType */._G.localStorageKey.browseLayoutType, newLayoutType, twoWeeks);
        }
        // updates layout in DL
        (0,vehicle/* addToDataLayer */.Bk)({
            browseLayout: newLayoutType
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_results_toolbar_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_results_toolbar_module_default())["deal-count"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (search_results_toolbar_module_default()).label,
                        children: "Showing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (search_results_toolbar_module_default()).count,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build/* default */.ZP, {
                                start: 0,
                                end: pricesTotal,
                                separator: ",",
                                delay: 0,
                                useEasing: true,
                                children: function(param) {
                                    var countUpRef = param.countUpRef;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            ref: countUpRef
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: (search_results_toolbar_module_default()).type,
                                children: [
                                    isVans ? " Van " : " Car ",
                                    "leasing"
                                ]
                            }),
                            " deals"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (search_results_toolbar_module_default())["save-search-container"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveTrigger/* SaveTrigger */.N, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (search_results_toolbar_module_default()).filters,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (search_results_toolbar_module_default()).layouts,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: layoutType === "grid" ? (search_results_toolbar_module_default()).inactive : "",
                                size: system/* Size.Medium */.$u.Medium,
                                hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                onClick: function() {
                                    return handleLayoutChange("list");
                                },
                                icon: "List",
                                hasBackground: false
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                className: layoutType === "list" || !layoutType ? (search_results_toolbar_module_default()).inactive : "",
                                size: system/* Size.Medium */.$u.Medium,
                                hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                                onClick: function() {
                                    return handleLayoutChange("grid");
                                },
                                icon: "Grip",
                                hasBackground: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropdown, {})
                ]
            })
        ]
    });
};
SearchResultsToolbar.propTypes = {
    isVans: prop_types.bool.isRequired
};

;// CONCATENATED MODULE: ./components/views/SearchResultsToolbar/index.js


// EXTERNAL MODULE: ./lib/loaders.js
var loaders = __webpack_require__(27386);
// EXTERNAL MODULE: ./store/reducers/system.js
var reducers_system = __webpack_require__(35371);
// EXTERNAL MODULE: ./store/selectors/loader.js
var loader = __webpack_require__(56428);
;// CONCATENATED MODULE: ./components/views/SearchResultsAndFilters/SearchResultsAndFilters.js





















var SearchFilters = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(6261), __webpack_require__.e(9878), __webpack_require__.e(2367), __webpack_require__.e(4398), __webpack_require__.e(15), __webpack_require__.e(1947)]).then(__webpack_require__.bind(__webpack_require__, 91947));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91947)
            ];
        }
    },
    ssr: false
});
var SearchPills = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8075), __webpack_require__.e(9878), __webpack_require__.e(2914)]).then(__webpack_require__.bind(__webpack_require__, 12914));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12914)
            ];
        }
    },
    ssr: false
});
var PADDING_BOTTOM = 40;
var SearchResultsAndFilters = function(param) {
    var isVans = param.isVans, status = param.status, setStatus = param.setStatus;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 991
    });
    var fetchingSearchResultsLoader = (0,es/* useSelector */.v9)(function(state) {
        return (0,loader/* selectLoaderExists */.u)(state, loaders/* LOADERS.fetchingSearchResults */.Y.fetchingSearchResults);
    });
    var filterCount = (0,es/* useSelector */.v9)(search/* selectCountOfSearchParameters */.F_);
    var vehicleTotal = (0,es/* useSelector */.v9)(search/* selectVehicleTotal */.UQ);
    var ref = (0,react.useState)(true), areFiltersVisible = ref[0], setAreFiltersVisible = ref[1];
    var ref1 = (0,react.useState)(false), isMobileFiltersOpen = ref1[0], setIsMobileFiltersOpen = ref1[1];
    var ref2 = (0,react.useState)(""), layoutType = ref2[0], setLayoutType = ref2[1];
    var ref3 = (0,react.useState)([]), visibleFilters = ref3[0], setVisibleFilters = ref3[1];
    var ref4 = (0,react.useState)(""), toggleId = ref4[0], setToggleId = ref4[1];
    (0,react.useEffect)(function() {
        if ((0,utilities_system/* storageAvailable */.oZ)("localStorage")) {
            var storageKey = (0,utilities_system/* getWithExpiry */.jE)(constants/* constants.localStorageKey.browseLayoutType */._G.localStorageKey.browseLayoutType);
            if (storageKey) {
                (0,vehicle/* addToDataLayer */.Bk)({
                    browseLayout: storageKey
                });
                setLayoutType(storageKey);
            } else {
                var defaultLayoutType = "grid";
                setLayoutType(defaultLayoutType);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            var filterControls = document.querySelector(".search__filter-controls");
            var filterControlsYCoord = filterControls.getBoundingClientRect().y;
            var calculatedPadding = filterControlsYCoord > 0 ? filterControlsYCoord : 0;
            filterControls.style.paddingBottom = "".concat(calculatedPadding + PADDING_BOTTOM, "px");
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (typeof window.fbq !== "undefined") {
            window.fbq("track", "Search", {
                // eslint-disable-next-line camelcase
                content_type: "vehicle_offer"
            });
        }
    }, []);
    (0,react.useEffect)(function() {
        dispatch((0,reducers_system/* storeShowBenefitsModal */.x3)(true));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (fetchingSearchResultsLoader) {
            setStatus(constants/* constants.componentStatus.LOADING */._G.componentStatus.LOADING);
        } else {
            setStatus(constants/* constants.componentStatus.COMPLETE */._G.componentStatus.COMPLETE);
        }
    }, [
        fetchingSearchResultsLoader,
        setStatus,
        status
    ]);
    var toggleMobileFilters = function() {
        setIsMobileFiltersOpen(function(prev) {
            return !prev;
        });
    };
    var toggleFilter = function(id) {
        var isFilterVisible = visibleFilters.includes(id);
        if (!isFilterVisible) {
            dispatch((0,reducers_search/* openSearchFilter */.I6)(id));
            var leaseDetails = [
                constants/* FILTER_MONTHLY_PAYMENT */.cF,
                constants/* FILTER_INITIAL_PAYMENT */.Cl,
                constants/* FILTER_MILEAGES */.Og,
                constants/* FILTER_TERMS */.Hx,
                constants/* FILTER_DELIVERY */.qU,
                constants/* FILTER_INCLUSIVE_BENEFITS */.s9,
                constants/* FILTER_SORT_BY */.NK, 
            ];
            if (leaseDetails.includes(id)) {
                setVisibleFilters(function(prev) {
                    return (0,_to_consumable_array/* default */.Z)(prev).concat([
                        id
                    ]);
                });
            } else {
                setToggleId(id);
            }
        } else {
            setVisibleFilters(function(prev) {
                return prev.filter(function(item) {
                    return item !== id;
                });
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container--search-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mobile-filters",
                children: [
                    isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSearch/* TextSearch */.N, {
                        visibleFilters: visibleFilters,
                        isMobile: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        size: system/* Size.Medium */.$u.Medium,
                        hierarchy: Button/* ButtonHierarchy.Black */.B.Black,
                        className: "search__filter-button",
                        onClick: toggleMobileFilters,
                        icon: "SlidersHorizontal"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-pills",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPills, {
                    hasPadding: false
                })
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* BottomSheet */.R, {
                expandOnContentDrag: true,
                scrollLocking: false,
                open: isMobileFiltersOpen,
                onDismiss: toggleMobileFilters,
                snapPoints: function(param) {
                    var maxHeight = param.maxHeight;
                    return [
                        maxHeight - 8
                    ];
                },
                header: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-filters-sheet-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            label: "Cancel",
                            hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                            size: system/* Size.Large */.$u.Large,
                            className: "header-button",
                            onClick: toggleMobileFilters
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "Filters"
                        })
                    ]
                }),
                footer: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mobile-filters-sheet-footer",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            hasUnderline: true,
                            size: system/* Size.Large */.$u.Large,
                            className: "clear-button",
                            hierarchy: Button/* ButtonHierarchy.Text */.B.Text,
                            label: "Clear all (".concat(filterCount, ")"),
                            disabled: filterCount === 0,
                            onClick: function() {
                                setVisibleFilters([]);
                                dispatch((0,reducers_search/* clearAllSearchState */.xs)());
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: system/* Size.Large */.$u.Large,
                            hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                            retainWidthOnLoadingState: true,
                            isLoading: fetchingSearchResultsLoader,
                            label: "Search ".concat(isVans ? "vans" : "cars"),
                            disabled: vehicleTotal === 0,
                            onClick: toggleMobileFilters
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mobile-filters-sheet",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilters, {
                        isMobile: true,
                        toggleFilter: toggleFilter,
                        isVans: isVans,
                        setIsMobileFiltersOpen: setIsMobileFiltersOpen,
                        visibleFilters: visibleFilters,
                        setVisibleFilters: setVisibleFilters,
                        toggleId: toggleId,
                        setToggleId: setToggleId
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-page-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container--search ".concat(!areFiltersVisible ? "hidden-filters" : ""),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "search__filter-controls",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilters, {
                                visibleFilters: visibleFilters,
                                setVisibleFilters: setVisibleFilters,
                                toggleFilter: toggleFilter,
                                isMobile: false,
                                isVans: isVans,
                                toggleId: toggleId,
                                setToggleId: setToggleId
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "search__container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsToolbar, {
                                    setAreFiltersVisible: setAreFiltersVisible,
                                    areFiltersVisible: areFiltersVisible,
                                    isVans: isVans,
                                    layoutType: layoutType,
                                    setLayoutType: setLayoutType
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults, {
                                    layoutType: layoutType,
                                    isVans: isVans,
                                    status: status
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportTab/* SupportTab */.F, {})
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/views/SearchResultsAndFilters/index.js



/***/ }),

/***/ 92311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ selectErrorList; },
/* harmony export */   "JS": function() { return /* binding */ selectErrorMessage; },
/* harmony export */   "Yp": function() { return /* binding */ selectErrorByKey; },
/* harmony export */   "zh": function() { return /* binding */ selectError; }
/* harmony export */ });
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68697);

var getError = function(state) {
    return state.error;
};
var selectErrorList = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSelector */ .P1)([
    getError
], function(error) {
    return error.list;
});
var selectErrorMessage = function(state, error) {
    var errorList = selectErrorList(state).filter(function(item) {
        return item && item.key === error;
    });
    return errorList.length ? errorList[0].message : "";
};
var selectError = function(state, error) {
    return selectErrorList(state).filter(function(item) {
        return item && item.key === error;
    })[0];
};
var selectErrorByKey = function(key) {
    return function(state) {
        return selectErrorList(state).filter(function(i) {
            return i && i.key === key;
        })[0];
    };
};


/***/ }),

/***/ 57807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_pagination___LfPQ","page-item":"pagination_page-item__XEnhm","page-link":"pagination_page-link__yj4U2","active":"pagination_active__GQYRT","disabled":"pagination_disabled__TnM8X","phAnimation":"pagination_phAnimation__2Zgxw"};

/***/ }),

/***/ 61016:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"sort-by-dropdown_select__4gkd_","sort-by-label":"sort-by-dropdown_sort-by-label___6Gxg","container":"sort-by-dropdown_container__fFaVR","hr":"sort-by-dropdown_hr___fdAG","toggle-row":"sort-by-dropdown_toggle-row__aGXrL","toggle":"sort-by-dropdown_toggle__EU2q_","button--toggle":"sort-by-dropdown_button--toggle__Kb60L","active":"sort-by-dropdown_active__blTdw","buttons__container":"sort-by-dropdown_buttons__container__RiWxY","label":"sort-by-dropdown_label__5nNDs","checkbox-label":"sort-by-dropdown_checkbox-label__BaB1l","checkbox--label":"sort-by-dropdown_checkbox--label__qsqAm","select--mileage":"sort-by-dropdown_select--mileage__rLoFs","checkbox--disabled":"sort-by-dropdown_checkbox--disabled__FHfL1","options":"sort-by-dropdown_options__8QdoR","show":"sort-by-dropdown_show__bkMAa","phAnimation":"sort-by-dropdown_phAnimation__n4YP8"};

/***/ }),

/***/ 58802:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search--input":"text-search_search--input__zJtMj","search--inputinput":"text-search_search--inputinput__qsnJj","input":"text-search_input__9LfkM","icon":"text-search_icon__YmWkG","label":"text-search_label__8LtgM","phAnimation":"text-search_phAnimation__Ysp1y"};

/***/ }),

/***/ 62312:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"information-banner_container__YfIRn","phAnimation":"information-banner_phAnimation__yLNM2"};

/***/ }),

/***/ 53644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"score":"loco-score_score___FxZc","ring":"loco-score_ring__zuCKC","container":"loco-score_container__p90CW","text":"loco-score_text__w_aMB","title":"loco-score_title__zoTzI","description":"loco-score_description__MfcQu","phAnimation":"loco-score_phAnimation__ElO02"};

/***/ }),

/***/ 17490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"sell-your-vehicle-banner_main__rLAoi","content":"sell-your-vehicle-banner_content__TrEor","end":"sell-your-vehicle-banner_end__7ahPZ","title":"sell-your-vehicle-banner_title__FZTof","text":"sell-your-vehicle-banner_text__3Tjst","button":"sell-your-vehicle-banner_button___mYdB","phAnimation":"sell-your-vehicle-banner_phAnimation__0NHTs"};

/***/ }),

/***/ 80001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reverse-image":"vehicle-image_reverse-image__uOgl_","padded-image":"vehicle-image_padded-image__sESfX","wrapper":"vehicle-image_wrapper__zluzR","arrows":"vehicle-image_arrows__4kG9G","dots":"vehicle-image_dots__RtU0B","dot":"vehicle-image_dot__bxknn","close":"vehicle-image_close__agwhd","far":"vehicle-image_far___i7DM","too-far":"vehicle-image_too-far__Mglyo","active":"vehicle-image_active__a6CKC","carousel":"vehicle-image_carousel__kVC1q","item":"vehicle-image_item__XBP0m","content":"vehicle-image_content__qHmo1","spec-image":"vehicle-image_spec-image__EEsLS","phAnimation":"vehicle-image_phAnimation__X2gd8"};

/***/ }),

/***/ 77513:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"no-results_container___9XPW","phAnimation":"no-results_phAnimation__q4lqx"};

/***/ }),

/***/ 89585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"save-search-container":"search-results-toolbar_save-search-container__s_po9","main":"search-results-toolbar_main__RTtAA","count":"search-results-toolbar_count__EBEP7","label":"search-results-toolbar_label__LrWmm","type":"search-results-toolbar_type__wVzfV","filters":"search-results-toolbar_filters__rqJGL","layouts":"search-results-toolbar_layouts__3xeUG","inactive":"search-results-toolbar_inactive__sJnAV","grouping":"search-results-toolbar_grouping__tW8yY","deal-count":"search-results-toolbar_deal-count__JRfVC","phAnimation":"search-results-toolbar_phAnimation__VwhdE"};

/***/ }),

/***/ 18352:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);